import { useMemo } from "react";

// Which dashboard analytics a store gets. This is the same rule as the
// backend's Store#analytics_tier, which is what actually guards the endpoints;
// the client copy only decides which tabs render their real data and which
// show the locked preview, so the two must agree or a tab either asks for data
// the API refuses (403 plan_feature_locked) or hides data the store paid for.
//
//   current_plan "advanced" -> advanced
//   current_plan "growth"   -> insights
//   current_plan "starter"  -> basic
//   blank / "" / null       -> advanced while trial_expires_at is in the
//                              future, else basic
//
// subscription_status is deliberately ignored: trialing, past_due and manually
// granted plans keep their plan, and canceled stores already have a blank plan.
export const PLAN_TIERS = ["basic", "insights", "advanced"];

export function planTier(store, now = new Date()) {
  const plan =
    typeof store?.current_plan === "string" ? store.current_plan.trim() : "";

  if (plan === "advanced") return "advanced";
  if (plan === "growth") return "insights";
  if (plan === "starter") return "basic";
  if (plan) return "basic";

  const trialEnd = store?.trial_expires_at
    ? new Date(store.trial_expires_at)
    : null;
  if (trialEnd && !Number.isNaN(trialEnd.getTime()) && trialEnd > now) {
    return "advanced";
  }
  return "basic";
}

// The tier a dashboard tab needs.
export const TAB_REQUIRED_TIER = {
  overview: "basic",
  insights: "insights",
  advanced: "advanced",
};

export function tierAllows(tier, required) {
  return PLAN_TIERS.indexOf(tier) >= PLAN_TIERS.indexOf(required);
}

export default function usePlanTier(selectedStore) {
  const currentPlan = selectedStore?.current_plan;
  const trialExpiresAt = selectedStore?.trial_expires_at;
  return useMemo(
    () =>
      planTier({
        current_plan: currentPlan,
        trial_expires_at: trialExpiresAt,
      }),
    [currentPlan, trialExpiresAt],
  );
}
